export const QNA_MAX_IMAGE_LENGTH = 4;
